import angular from 'angular'
import csvDownloadsDir from './csv_downloads/csv_downloads_directive'
import enhancedReportsDir from './enhanced_reports/enhanced_reports_directive'
import reportTableDir from './report_table/report_table_directive'
import analyticsApi from './analytics_service'
import AnalyticsCtrl from './analytics_controller'
import domoEmbedsModule from './domo_embeds'

export default angular
  .module('adminPanel.analytics', ['adminPanel.domoEmbeds'])
  .directive('csvDownloads', csvDownloadsDir)
  .directive('enhancedReports', enhancedReportsDir)
  .directive('reportTable', reportTableDir)
  .factory('analyticsApi', analyticsApi)
  .controller('AnalyticsCtrl', AnalyticsCtrl)
